{
  "as_at": "2026-10-25T06:49:07Z",
  "lists": {
    "Complaints": {
      "columns": [
        {
          "displayName": "AcknowledgedAt",
          "format": "dateTime",
          "hidden": false,
          "name": "AcknowledgedAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "AdvocateInvolved",
          "hidden": false,
          "name": "AdvocateInvolved",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "Anonymous",
          "hidden": false,
          "name": "Anonymous",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "AssessmentNote",
          "hidden": false,
          "multiline": true,
          "name": "AssessmentNote",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "BusinessUnit",
          "hidden": false,
          "name": "BusinessUnit",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "choices": [
            "Employee conduct",
            "Information provision",
            "Other",
            "Pricing and billing",
            "Privacy and confidentiality",
            "Service access/availability",
            "Service failure",
            "Service quality - Activities/Lifestyle",
            "Service quality - Assessment and planning",
            "Service quality - Equipment",
            "Service quality - Meal quality",
            "Service quality - Personal/clinical care",
            "Service quality - Physical environment"
          ],
          "displayName": "Category",
          "hidden": false,
          "name": "Category",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "choices": [
            "Oral",
            "Written"
          ],
          "displayName": "Channel",
          "hidden": false,
          "name": "Channel",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ClosedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "ClosedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Open",
            "Closing",
            "Closed"
          ],
          "displayName": "ClosureStatus",
          "hidden": false,
          "name": "ClosureStatus",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "CommissionerRouteAdvisedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "CommissionerRouteAdvisedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ComplainantEmail",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplainantEmail",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ComplainantName",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplainantName",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ComplainantPhone",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplainantPhone",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "Partly",
            "No"
          ],
          "displayName": "ComplainantSatisfied",
          "hidden": false,
          "name": "ComplainantSatisfied",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Description",
          "hidden": false,
          "multiline": true,
          "name": "Description",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "EffectivenessEvaluation",
          "hidden": false,
          "multiline": true,
          "name": "EffectivenessEvaluation",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ExpectedTimeframe",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ExpectedTimeframe",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "InvestigationRequired",
          "hidden": false,
          "name": "InvestigationRequired",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "ManagingUnit",
          "hidden": false,
          "name": "ManagingUnit",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "OnBehalfOf",
          "hidden": false,
          "name": "OnBehalfOf",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "OpenDisclosureUsed",
          "hidden": false,
          "name": "OpenDisclosureUsed",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Outcome",
          "hidden": false,
          "multiline": true,
          "name": "Outcome",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "OutcomeNotifiedAt",
          "format": "dateTime",
          "hidden": false,
          "name": "OutcomeNotifiedAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "PositionsResponsible",
          "hidden": false,
          "multiline": true,
          "name": "PositionsResponsible",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "No priority",
            "Urgent",
            "High",
            "Medium",
            "Low"
          ],
          "displayName": "Priority",
          "hidden": false,
          "name": "Priority",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ReceivedOn",
          "format": "dateTime",
          "hidden": false,
          "name": "ReceivedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "RecipientClientId",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "RecipientClientId",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "RecipientName",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "RecipientName",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Reference",
          "hidden": false,
          "name": "Reference",
          "readOnly": true,
          "required": false,
          "type": "calculated"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "RegulatorReferred",
          "hidden": false,
          "name": "RegulatorReferred",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "RegulatorResponseDueOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "RegulatorResponseDueOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "RelatedTo",
          "hidden": false,
          "multiline": true,
          "name": "RelatedTo",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "RelevantPolicy",
          "hidden": false,
          "multiline": true,
          "name": "RelevantPolicy",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "ReviewOptionsGiven",
          "hidden": false,
          "name": "ReviewOptionsGiven",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Worker",
            "Individual",
            "Supporter",
            "Other"
          ],
          "displayName": "SourceType",
          "hidden": false,
          "name": "SourceType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "New",
            "Actioning",
            "Evaluating",
            "Completed",
            "Cancelled"
          ],
          "displayName": "Status",
          "hidden": false,
          "name": "Status",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "SystemicIssue",
          "hidden": false,
          "name": "SystemicIssue",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "TargetResolutionOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "TargetResolutionOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "TrainingDelivered",
          "hidden": false,
          "multiline": true,
          "name": "TrainingDelivered",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "UnderlyingReason",
          "hidden": false,
          "multiline": true,
          "name": "UnderlyingReason",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "WhistleblowerElection",
          "hidden": false,
          "name": "WhistleblowerElection",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "WithdrawnOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "WithdrawnOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Complaints Audit Log": {
      "columns": [
        {
          "displayName": "Actor",
          "hidden": false,
          "name": "Actor",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "ActorUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ActorUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "EntryTimestamp",
          "format": "dateTime",
          "hidden": false,
          "name": "EntryTimestamp",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "StateChange",
            "InvestigationStep",
            "ActionTaken",
            "Note"
          ],
          "displayName": "EntryType",
          "hidden": false,
          "name": "EntryType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "FieldChanged",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "FieldChanged",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "Acknowledgement",
            "AuditMeeting",
            "Communication",
            "Consultation",
            "Disclosure",
            "InformationRequest",
            "Notification",
            "ProceduralFairness",
            "ProgressUpdate",
            "RegulatorDecision",
            "RegulatorRequirement",
            "ReprisalConcern",
            "Review",
            "RTW",
            "SitePreservation",
            "Support"
          ],
          "displayName": "LogKind",
          "hidden": false,
          "name": "LogKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NewValue",
          "hidden": false,
          "multiline": true,
          "name": "NewValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Note",
          "hidden": false,
          "multiline": true,
          "name": "Note",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "OldValue",
          "hidden": false,
          "multiline": true,
          "name": "OldValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ParentRef",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ParentRef",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Continuous Improvement": {
      "columns": [
        {
          "choices": [
            "Agent",
            "Human"
          ],
          "displayName": "ActionMode",
          "hidden": false,
          "name": "ActionMode",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "BaselineSnapshot",
          "hidden": false,
          "multiline": true,
          "name": "BaselineSnapshot",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "BusinessUnit",
          "hidden": false,
          "name": "BusinessUnit",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Communication/consultation",
            "Repair/maintenance",
            "Service/product review",
            "Staff training/development",
            "System/process review"
          ],
          "displayName": "Category",
          "hidden": false,
          "name": "Category",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ClosedOn",
          "format": "dateTime",
          "hidden": false,
          "name": "ClosedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ClosingComments",
          "hidden": false,
          "multiline": true,
          "name": "ClosingComments",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Open",
            "Closing",
            "Closed"
          ],
          "displayName": "ClosureStatus",
          "hidden": false,
          "name": "ClosureStatus",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "CompleteBy",
          "format": "dateTime",
          "hidden": false,
          "name": "CompleteBy",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Description",
          "hidden": false,
          "multiline": true,
          "name": "Description",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "IdentifiedOn",
          "format": "dateTime",
          "hidden": false,
          "name": "IdentifiedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Issue",
          "hidden": false,
          "multiline": true,
          "name": "Issue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "ManagingUnit",
          "hidden": false,
          "name": "ManagingUnit",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "OriginatingItems",
          "hidden": false,
          "multiline": true,
          "name": "OriginatingItems",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Outcome",
          "hidden": false,
          "multiline": true,
          "name": "Outcome",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "OwnerUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "OwnerUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "PositionsResponsible",
          "hidden": false,
          "multiline": true,
          "name": "PositionsResponsible",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "No priority",
            "Urgent",
            "High",
            "Medium",
            "Low"
          ],
          "displayName": "Priority",
          "hidden": false,
          "name": "Priority",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "RaisedByUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "RaisedByUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Reference",
          "hidden": false,
          "name": "Reference",
          "readOnly": true,
          "required": false,
          "type": "calculated"
        },
        {
          "displayName": "RelevantPolicy",
          "hidden": false,
          "multiline": true,
          "name": "RelevantPolicy",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ResolutionApprovedBy",
          "hidden": false,
          "name": "ResolutionApprovedBy",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "ResolutionApprovedByUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ResolutionApprovedByUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ReviewDue",
          "format": "dateOnly",
          "hidden": false,
          "name": "ReviewDue",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ReviewEvidence",
          "hidden": false,
          "multiline": true,
          "name": "ReviewEvidence",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ReviewMethod",
          "hidden": false,
          "multiline": true,
          "name": "ReviewMethod",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Better",
            "Same",
            "Worse"
          ],
          "displayName": "ReviewVerdict",
          "hidden": false,
          "name": "ReviewVerdict",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "StartOn",
          "format": "dateTime",
          "hidden": false,
          "name": "StartOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "New",
            "Actioning",
            "Evaluating",
            "Completed",
            "Cancelled"
          ],
          "displayName": "Status",
          "hidden": false,
          "name": "Status",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Continuous Improvement Audit Log": {
      "columns": [
        {
          "displayName": "Actor",
          "hidden": false,
          "name": "Actor",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "ActorUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ActorUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "EntryTimestamp",
          "format": "dateTime",
          "hidden": false,
          "name": "EntryTimestamp",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "StateChange",
            "InvestigationStep",
            "ActionTaken",
            "Note"
          ],
          "displayName": "EntryType",
          "hidden": false,
          "name": "EntryType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "FieldChanged",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "FieldChanged",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "Acknowledgement",
            "AuditMeeting",
            "Communication",
            "Consultation",
            "Disclosure",
            "InformationRequest",
            "Notification",
            "ProceduralFairness",
            "ProgressUpdate",
            "RegulatorDecision",
            "RegulatorRequirement",
            "ReprisalConcern",
            "Review",
            "RTW",
            "SitePreservation",
            "Support"
          ],
          "displayName": "LogKind",
          "hidden": false,
          "name": "LogKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NewValue",
          "hidden": false,
          "multiline": true,
          "name": "NewValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Note",
          "hidden": false,
          "multiline": true,
          "name": "Note",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "OldValue",
          "hidden": false,
          "multiline": true,
          "name": "OldValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ParentRef",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ParentRef",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Feedback": {
      "columns": [
        {
          "displayName": "AcknowledgedAt",
          "format": "dateTime",
          "hidden": false,
          "name": "AcknowledgedAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "Anonymous",
          "hidden": false,
          "name": "Anonymous",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "BusinessUnit",
          "hidden": false,
          "name": "BusinessUnit",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "choices": [
            "Compliment",
            "Feedback",
            "Suggestion"
          ],
          "displayName": "Category",
          "hidden": false,
          "name": "Category",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "choices": [
            "Oral",
            "Written"
          ],
          "displayName": "Channel",
          "hidden": false,
          "name": "Channel",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "ClassifiedAsComplaint",
          "hidden": false,
          "name": "ClassifiedAsComplaint",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ClosedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "ClosedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Open",
            "Closing",
            "Closed"
          ],
          "displayName": "ClosureStatus",
          "hidden": false,
          "name": "ClosureStatus",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "CommissionerRouteAdvisedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "CommissionerRouteAdvisedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Description",
          "hidden": false,
          "multiline": true,
          "name": "Description",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "EffectivenessEvaluation",
          "hidden": false,
          "multiline": true,
          "name": "EffectivenessEvaluation",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "ManagingUnit",
          "hidden": false,
          "name": "ManagingUnit",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "PositionsResponsible",
          "hidden": false,
          "multiline": true,
          "name": "PositionsResponsible",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ProviderEmail",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ProviderEmail",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ProviderName",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ProviderName",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ProviderPhone",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ProviderPhone",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "RaisesIssue",
          "hidden": false,
          "name": "RaisesIssue",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ReceivedOn",
          "format": "dateTime",
          "hidden": false,
          "name": "ReceivedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Reference",
          "hidden": false,
          "name": "Reference",
          "readOnly": true,
          "required": false,
          "type": "calculated"
        },
        {
          "displayName": "RelatedTo",
          "hidden": false,
          "multiline": true,
          "name": "RelatedTo",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "RelevantPolicy",
          "hidden": false,
          "multiline": true,
          "name": "RelevantPolicy",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ResponseGivenAt",
          "format": "dateTime",
          "hidden": false,
          "name": "ResponseGivenAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Worker",
            "Individual",
            "Supporter",
            "Other"
          ],
          "displayName": "SourceType",
          "hidden": false,
          "name": "SourceType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "New",
            "Actioning",
            "Evaluating",
            "Completed",
            "Cancelled"
          ],
          "displayName": "Status",
          "hidden": false,
          "name": "Status",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "TrainingDelivered",
          "hidden": false,
          "multiline": true,
          "name": "TrainingDelivered",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "WhistleblowerElection",
          "hidden": false,
          "name": "WhistleblowerElection",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "WithdrawnOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "WithdrawnOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Feedback Audit Log": {
      "columns": [
        {
          "displayName": "Actor",
          "hidden": false,
          "name": "Actor",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "ActorUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ActorUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "EntryTimestamp",
          "format": "dateTime",
          "hidden": false,
          "name": "EntryTimestamp",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "StateChange",
            "InvestigationStep",
            "ActionTaken",
            "Note"
          ],
          "displayName": "EntryType",
          "hidden": false,
          "name": "EntryType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "FieldChanged",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "FieldChanged",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "Acknowledgement",
            "AuditMeeting",
            "Communication",
            "Consultation",
            "Disclosure",
            "InformationRequest",
            "Notification",
            "ProceduralFairness",
            "ProgressUpdate",
            "RegulatorDecision",
            "RegulatorRequirement",
            "ReprisalConcern",
            "Review",
            "RTW",
            "SitePreservation",
            "Support"
          ],
          "displayName": "LogKind",
          "hidden": false,
          "name": "LogKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NewValue",
          "hidden": false,
          "multiline": true,
          "name": "NewValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Note",
          "hidden": false,
          "multiline": true,
          "name": "Note",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "OldValue",
          "hidden": false,
          "multiline": true,
          "name": "OldValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ParentRef",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ParentRef",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Incidents": {
      "columns": [
        {
          "displayName": "AffectedViewsConsidered",
          "hidden": false,
          "multiline": true,
          "name": "AffectedViewsConsidered",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "AllegationAgainstWorker",
          "hidden": false,
          "name": "AllegationAgainstWorker",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "AllegationFirstHeldOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "AllegationFirstHeldOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "AwareAt",
          "format": "dateTime",
          "hidden": false,
          "name": "AwareAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "BusinessUnit",
          "hidden": false,
          "name": "BusinessUnit",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "choices": [
            "Abscond/Absence/Non response to scheduled visit",
            "Abuse - Financial",
            "Abuse - Neglect",
            "Abuse - Other inappropriate behaviour",
            "Abuse - Physical assault/aggression",
            "Abuse - Psychological, Emotional",
            "Abuse - Sexual",
            "Illness/injury - Choking",
            "Illness/injury - Fracture, Dislocation, Strain",
            "Illness/injury - Infection",
            "Illness/injury - Other",
            "Illness/injury - Psychological, Emotional",
            "Illness/injury - Skin cut, tear, bruise, burn, rash",
            "Illness/injury - Unexpected death",
            "Illness/Injury - Wound/pressure injury",
            "Medication - Documentation error",
            "Medication - Missed, Not taken",
            "Medication - Other error",
            "Medication - Wrong dose, route, time, type",
            "Medication - Wrong person",
            "Other",
            "Other - Business interruption",
            "Other - Chemical/Biological spill, hazard",
            "Other - Environmental harm",
            "Other - Food quality, safety",
            "Other - Fraud",
            "Other - Hazard, Near miss",
            "Other - Property loss, damage, malfunction",
            "Other - Security breach",
            "Other - System/equipment failure",
            "Restrictive Practice - Inappropriate use"
          ],
          "displayName": "Category",
          "hidden": false,
          "name": "Category",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "displayName": "ClaimAcknowledgedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "ClaimAcknowledgedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ClaimForwardedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "ClaimForwardedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ClaimReceivedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "ClaimReceivedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Weekly payments",
            "Part 5 Div 4",
            "Part 5 Div 7 within excess",
            "Part 5 Div 7 outside excess",
            "Death claim (ss 235-241)",
            "Accident Compensation Act 1985 claim"
          ],
          "displayName": "ClaimType",
          "hidden": false,
          "name": "ClaimType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ClosedOn",
          "format": "dateTime",
          "hidden": false,
          "name": "ClosedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ClosingComments",
          "hidden": false,
          "multiline": true,
          "name": "ClosingComments",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Open",
            "Closing",
            "Closed"
          ],
          "displayName": "ClosureStatus",
          "hidden": false,
          "name": "ClosureStatus",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "CognitionLevel",
          "hidden": false,
          "multiline": true,
          "name": "CognitionLevel",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Confidence",
          "hidden": false,
          "name": "Confidence",
          "readOnly": false,
          "required": false,
          "type": "number"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "CorrectiveActionNature",
          "hidden": false,
          "multiline": true,
          "name": "CorrectiveActionNature",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "CorrectiveActionRequired",
          "hidden": false,
          "name": "CorrectiveActionRequired",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Description",
          "hidden": false,
          "multiline": true,
          "name": "Description",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "DraftCategory",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "DraftCategory",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "No rating",
            "Insignificant",
            "Minor",
            "Moderate",
            "Major",
            "Catastrophic"
          ],
          "displayName": "DraftSeverity",
          "hidden": false,
          "name": "DraftSeverity",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "SaH",
            "NDIS",
            "Staff",
            "Other"
          ],
          "displayName": "DraftStream",
          "hidden": false,
          "name": "DraftStream",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "DuplicateOfRef",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "DuplicateOfRef",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "EnrichedAt",
          "format": "dateTime",
          "hidden": false,
          "name": "EnrichedAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "EnrichmentPacket",
          "hidden": false,
          "multiline": true,
          "name": "EnrichmentPacket",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "shiftcare-api",
            "none"
          ],
          "displayName": "EnrichmentSource",
          "hidden": false,
          "name": "EnrichmentSource",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ExternalId",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ExternalId",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ExternalNotified",
          "hidden": false,
          "multiline": true,
          "name": "ExternalNotified",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ExternalOutcome",
          "hidden": false,
          "multiline": true,
          "name": "ExternalOutcome",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "FinalReportDueOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "FinalReportDueOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "FinalReportGivenAt",
          "format": "dateTime",
          "hidden": false,
          "name": "FinalReportGivenAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "FinalReportRequired",
          "hidden": false,
          "name": "FinalReportRequired",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "FurtherActionsProposed",
          "hidden": false,
          "multiline": true,
          "name": "FurtherActionsProposed",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "HandlerUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "HandlerUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "HarmConsequences",
          "hidden": false,
          "multiline": true,
          "name": "HarmConsequences",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "HarmDescription",
          "hidden": false,
          "multiline": true,
          "name": "HarmDescription",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Harm",
            "Potential harm",
            "Near miss (no harm)"
          ],
          "displayName": "HarmKind",
          "hidden": false,
          "name": "HarmKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "HrWhsTriageNeeded",
          "hidden": false,
          "name": "HrWhsTriageNeeded",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "ImmediateActions",
          "hidden": false,
          "multiline": true,
          "name": "ImmediateActions",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Occurred",
            "Alleged",
            "Suspected"
          ],
          "displayName": "IncidentBasis",
          "hidden": false,
          "name": "IncidentBasis",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "InfoWithheld",
          "hidden": false,
          "multiline": true,
          "name": "InfoWithheld",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "InjuredWorkerName",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "InjuredWorkerName",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "InjuredWorkerOccupation",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "InjuredWorkerOccupation",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "InjuredWorkerUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "InjuredWorkerUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "InjuryNoticeAcknowledgedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "InjuryNoticeAcknowledgedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Verbal",
            "Written"
          ],
          "displayName": "InjuryNoticeMethod",
          "hidden": false,
          "name": "InjuryNoticeMethod",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "InjuryNoticeReceivedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "InjuryNoticeReceivedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "InvestigationFindings",
          "hidden": false,
          "multiline": true,
          "name": "InvestigationFindings",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "InvestigationReason",
          "hidden": false,
          "multiline": true,
          "name": "InvestigationReason",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "InvestigationRequired",
          "hidden": false,
          "name": "InvestigationRequired",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Location",
          "hidden": false,
          "multiline": true,
          "name": "Location",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ManagementAssessment",
          "hidden": false,
          "multiline": true,
          "name": "ManagementAssessment",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "ManagingUnit",
          "hidden": false,
          "name": "ManagingUnit",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "MedicalCertificateForwardedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "MedicalCertificateForwardedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "MedicalCertificateReceivedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "MedicalCertificateReceivedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "MentalInjuryClaim",
          "hidden": false,
          "name": "MentalInjuryClaim",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "MentalInjuryNotifiedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "MentalInjuryNotifiedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NdisFurtherNoticeAt",
          "format": "dateTime",
          "hidden": false,
          "name": "NdisFurtherNoticeAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NdisInitialNoticeAt",
          "format": "dateTime",
          "hidden": false,
          "name": "NdisInitialNoticeAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NdisInitialNoticeMethod",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "NdisInitialNoticeMethod",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "24 hours",
            "5 business days"
          ],
          "displayName": "NdisNoticeClass",
          "hidden": false,
          "name": "NdisNoticeClass",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Death",
            "Serious injury",
            "Abuse or neglect",
            "Unlawful sexual or physical contact or assault",
            "Sexual misconduct (incl. grooming)",
            "Restrictive practice not per authorisation or BSP"
          ],
          "displayName": "NdisRiKind",
          "hidden": false,
          "name": "NdisRiKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "NotificationDueAt",
          "format": "dateTime",
          "hidden": false,
          "name": "NotificationDueAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NotifierPosition",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "NotifierPosition",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "NotifierUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "NotifierUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "OccurredOn",
          "format": "dateTime",
          "hidden": false,
          "name": "OccurredOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "OpenDisclosureAt",
          "format": "dateTime",
          "hidden": false,
          "name": "OpenDisclosureAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "OpenDisclosureUsed",
          "hidden": false,
          "name": "OpenDisclosureUsed",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "OtherPersonsInvolved",
          "hidden": false,
          "multiline": true,
          "name": "OtherPersonsInvolved",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "PersonsContactDetails",
          "hidden": false,
          "multiline": true,
          "name": "PersonsContactDetails",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "PoliceNotified",
          "hidden": false,
          "name": "PoliceNotified",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "PoliceNotifiedAt",
          "format": "dateTime",
          "hidden": false,
          "name": "PoliceNotifiedAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "PoliceReference",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "PoliceReference",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "PositionsResponsible",
          "hidden": false,
          "multiline": true,
          "name": "PositionsResponsible",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "Partly",
            "No"
          ],
          "displayName": "Preventable",
          "hidden": false,
          "name": "Preventable",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "RecipientClientId",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "RecipientClientId",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "RecipientName",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "RecipientName",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "SaH",
            "NDIS",
            "Staff",
            "Other"
          ],
          "displayName": "RecipientStream",
          "hidden": false,
          "name": "RecipientStream",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Reference",
          "hidden": false,
          "name": "Reference",
          "readOnly": true,
          "required": false,
          "type": "calculated"
        },
        {
          "displayName": "RegulatorReference",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "RegulatorReference",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "RelevantPolicy",
          "hidden": false,
          "multiline": true,
          "name": "RelevantPolicy",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ReportabilityAssessment",
          "hidden": false,
          "multiline": true,
          "name": "ReportabilityAssessment",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Pending",
            "NotReportable",
            "SIRS-P1",
            "SIRS-P2",
            "NDIS-Reportable",
            "WorkSafe",
            "Other"
          ],
          "displayName": "ReportabilityDecision",
          "hidden": false,
          "name": "ReportabilityDecision",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "NotReportable",
            "SIRS-P1",
            "SIRS-P2",
            "NDIS-Reportable",
            "WorkSafe",
            "Other",
            "Unsure"
          ],
          "displayName": "ReportabilityDraft",
          "hidden": false,
          "name": "ReportabilityDraft",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ReportabilityDraftNote",
          "hidden": false,
          "multiline": true,
          "name": "ReportabilityDraftNote",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ReportedBy",
          "hidden": false,
          "name": "ReportedBy",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "Reported By Email",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ReportedByEmail",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ReportedOn",
          "format": "dateTime",
          "hidden": false,
          "name": "ReportedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ReportedOnBehalfOf",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ReportedOnBehalfOf",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ReportedToAt",
          "format": "dateTime",
          "hidden": false,
          "name": "ReportedToAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ReportedToRole",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ReportedToRole",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ReporterPhone",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ReporterPhone",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "No reporting required",
            "External - SIRS P1",
            "External - SIRS P2",
            "External report required",
            "Internal report only"
          ],
          "displayName": "ReportingType",
          "hidden": false,
          "name": "ReportingType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ResolutionApprovedBy",
          "hidden": false,
          "name": "ResolutionApprovedBy",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "ResolutionApprovedByUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ResolutionApprovedByUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ResolutionApprovedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "ResolutionApprovedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ResolveBy",
          "format": "dateTime",
          "hidden": false,
          "name": "ResolveBy",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ReturnToWork",
          "hidden": false,
          "name": "ReturnToWork",
          "readOnly": false,
          "required": false,
          "type": "boolean"
        },
        {
          "displayName": "RtwKnowledgeOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "RtwKnowledgeOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "RtwPlanningStartedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "RtwPlanningStartedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Not applicable",
            "Yes",
            "Partially",
            "No"
          ],
          "displayName": "SatisfactoryResolution",
          "hidden": false,
          "name": "SatisfactoryResolution",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "No rating",
            "Insignificant",
            "Minor",
            "Moderate",
            "Major",
            "Catastrophic"
          ],
          "displayName": "Severity",
          "hidden": false,
          "name": "Severity",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "SirsAdditionalNoticeAt",
          "format": "dateTime",
          "hidden": false,
          "name": "SirsAdditionalNoticeAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Unreasonable use of force",
            "Unlawful sexual contact or inappropriate sexual conduct",
            "Psychological or emotional abuse",
            "Unexpected death",
            "Stealing or financial coercion by a worker",
            "Neglect",
            "Restrictive practice use",
            "Unexplained absence"
          ],
          "displayName": "SirsKind",
          "hidden": false,
          "name": "SirsKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "SirsNeglectExclusionRef",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "SirsNeglectExclusionRef",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "SirsNoticeAt",
          "format": "dateTime",
          "hidden": false,
          "name": "SirsNoticeAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "SirsNoticeMethod",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "SirsNoticeMethod",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "SirsPriorityBasis",
          "hidden": false,
          "multiline": true,
          "name": "SirsPriorityBasis",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "New",
            "Actioning",
            "Evaluating",
            "Completed",
            "Cancelled"
          ],
          "displayName": "Status",
          "hidden": false,
          "name": "Status",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "TriageNote",
          "hidden": false,
          "multiline": true,
          "name": "TriageNote",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "TriagedAt",
          "format": "dateTime",
          "hidden": false,
          "name": "TriagedAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "TriagedByUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "TriagedByUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No",
            "Unsure"
          ],
          "displayName": "UnderHarmonyControl",
          "hidden": false,
          "name": "UnderHarmonyControl",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "WitnessContactDetails",
          "hidden": false,
          "multiline": true,
          "name": "WitnessContactDetails",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Witnesses",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Witnesses",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Death",
            "Medical treatment within 48 hours of exposure to a substance",
            "Immediate in-patient treatment",
            "Immediate medical treatment for a listed injury",
            "Dangerous occurrence (s 37(2))"
          ],
          "displayName": "WorkSafeIncidentKind",
          "hidden": false,
          "name": "WorkSafeIncidentKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "WorkSafeNotifiable",
          "hidden": false,
          "name": "WorkSafeNotifiable",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "WorkSafeNotifiedAt",
          "format": "dateTime",
          "hidden": false,
          "name": "WorkSafeNotifiedAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "WorkSafeNotifiedByUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "WorkSafeNotifiedByUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "WorkSafeReference",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "WorkSafeReference",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "WorkSafeWrittenRecordAt",
          "format": "dateTime",
          "hidden": false,
          "name": "WorkSafeWrittenRecordAt",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "WorkerInjured",
          "hidden": false,
          "name": "WorkerInjured",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Office",
            "Client home",
            "Community",
            "Vehicle",
            "Other"
          ],
          "displayName": "WorkplaceType",
          "hidden": false,
          "name": "WorkplaceType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Incidents Audit Log": {
      "columns": [
        {
          "displayName": "Actor",
          "hidden": false,
          "name": "Actor",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "ActorUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ActorUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "EntryTimestamp",
          "format": "dateTime",
          "hidden": false,
          "name": "EntryTimestamp",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "StateChange",
            "InvestigationStep",
            "ActionTaken",
            "Note"
          ],
          "displayName": "EntryType",
          "hidden": false,
          "name": "EntryType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "FieldChanged",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "FieldChanged",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "Acknowledgement",
            "AuditMeeting",
            "Communication",
            "Consultation",
            "Disclosure",
            "InformationRequest",
            "Notification",
            "ProceduralFairness",
            "ProgressUpdate",
            "RegulatorDecision",
            "RegulatorRequirement",
            "ReprisalConcern",
            "Review",
            "RTW",
            "SitePreservation",
            "Support"
          ],
          "displayName": "LogKind",
          "hidden": false,
          "name": "LogKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NewValue",
          "hidden": false,
          "multiline": true,
          "name": "NewValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Note",
          "hidden": false,
          "multiline": true,
          "name": "Note",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "OldValue",
          "hidden": false,
          "multiline": true,
          "name": "OldValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ParentRef",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ParentRef",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Internal Audits": {
      "columns": [
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ApprovedByUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ApprovedByUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ApprovedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "ApprovedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "Internal audit",
            "System review"
          ],
          "displayName": "AuditKind",
          "hidden": false,
          "name": "AuditKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Awaiting Completion",
            "Completion Overdue",
            "In Progress",
            "Completed",
            "Approved"
          ],
          "displayName": "AuditStatus",
          "hidden": false,
          "name": "AuditStatus",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "AuditTemplate",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "AuditTemplate",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "AuditorIndependent",
          "hidden": false,
          "name": "AuditorIndependent",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "AuditorUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "AuditorUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "BusinessUnit",
          "hidden": false,
          "name": "BusinessUnit",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "CentroRef",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "CentroRef",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "CompletedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "CompletedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "DueOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "DueOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "Explanation",
          "hidden": false,
          "multiline": true,
          "name": "Explanation",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "FindingsLink",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "FindingsLink",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Recommendations",
          "hidden": false,
          "multiline": true,
          "name": "Recommendations",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "RecommendedFrequency",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "RecommendedFrequency",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ScorePct",
          "hidden": false,
          "name": "ScorePct",
          "readOnly": false,
          "required": false,
          "type": "number"
        },
        {
          "displayName": "TemplateVersion",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "TemplateVersion",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Internal Audits Audit Log": {
      "columns": [
        {
          "displayName": "Actor",
          "hidden": false,
          "name": "Actor",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "ActorUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ActorUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "EntryTimestamp",
          "format": "dateTime",
          "hidden": false,
          "name": "EntryTimestamp",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "StateChange",
            "InvestigationStep",
            "ActionTaken",
            "Note"
          ],
          "displayName": "EntryType",
          "hidden": false,
          "name": "EntryType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "FieldChanged",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "FieldChanged",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "Acknowledgement",
            "AuditMeeting",
            "Communication",
            "Consultation",
            "Disclosure",
            "InformationRequest",
            "Notification",
            "ProceduralFairness",
            "ProgressUpdate",
            "RegulatorDecision",
            "RegulatorRequirement",
            "ReprisalConcern",
            "Review",
            "RTW",
            "SitePreservation",
            "Support"
          ],
          "displayName": "LogKind",
          "hidden": false,
          "name": "LogKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NewValue",
          "hidden": false,
          "multiline": true,
          "name": "NewValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Note",
          "hidden": false,
          "multiline": true,
          "name": "Note",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "OldValue",
          "hidden": false,
          "multiline": true,
          "name": "OldValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ParentRef",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ParentRef",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Risk Register": {
      "columns": [
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "choices": [
            "All Stake holders (Clients: NDIS, Aged Care & Staff)",
            "Both NDIS & Aged Care",
            "Brokered or Private",
            "Gardening Team",
            "NDIS",
            "Residential Care Services",
            "Retirement Living Services",
            "Staff",
            "Support at Home Package"
          ],
          "displayName": "BusinessUnit",
          "hidden": false,
          "name": "BusinessUnit",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "choices": [
            "Open",
            "Closing",
            "Closed"
          ],
          "displayName": "ClosureStatus",
          "hidden": false,
          "name": "ClosureStatus",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Insignificant",
            "Minor",
            "Moderate",
            "Major",
            "Catastrophic"
          ],
          "displayName": "Consequence",
          "hidden": false,
          "name": "Consequence",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Description",
          "hidden": false,
          "multiline": true,
          "name": "Description",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "ExistingControls",
          "hidden": false,
          "multiline": true,
          "name": "ExistingControls",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "choices": [
            "Manual handling",
            "Fall from height",
            "Hazardous substance",
            "Occupational violence",
            "Other"
          ],
          "displayName": "HazardType",
          "hidden": false,
          "name": "HazardType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "Low",
            "Medium",
            "High",
            "Extreme"
          ],
          "displayName": "InherentRiskRating",
          "hidden": false,
          "name": "InherentRiskRating",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "InsuranceChecked",
          "hidden": false,
          "name": "InsuranceChecked",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "choices": [
            "Rare",
            "Unlikely",
            "Possible",
            "Likely",
            "Almost Certain"
          ],
          "displayName": "Likelihood",
          "hidden": false,
          "name": "Likelihood",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "OriginatingItems",
          "hidden": false,
          "multiline": true,
          "name": "OriginatingItems",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Reference",
          "hidden": false,
          "name": "Reference",
          "readOnly": true,
          "required": false,
          "type": "calculated"
        },
        {
          "choices": [
            "Insignificant",
            "Minor",
            "Moderate",
            "Major",
            "Catastrophic"
          ],
          "displayName": "ResidualConsequence",
          "hidden": false,
          "name": "ResidualConsequence",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Rare",
            "Unlikely",
            "Possible",
            "Likely",
            "Almost Certain"
          ],
          "displayName": "ResidualLikelihood",
          "hidden": false,
          "name": "ResidualLikelihood",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "Low",
            "Medium",
            "High",
            "Extreme"
          ],
          "displayName": "ResidualRiskRating",
          "hidden": false,
          "name": "ResidualRiskRating",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "ResolutionAgreedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "ResolutionAgreedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ResolutionCommunicatedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "ResolutionCommunicatedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "ReviewDate",
          "format": "dateTime",
          "hidden": false,
          "name": "ReviewDate",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Yes",
            "No"
          ],
          "displayName": "RiskAccepted",
          "hidden": false,
          "name": "RiskAccepted",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "RiskAcceptedByUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "RiskAcceptedByUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "RiskAcceptedOn",
          "format": "dateOnly",
          "hidden": false,
          "name": "RiskAcceptedOn",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "Clinical",
            "WHS",
            "Operational",
            "Financial",
            "Compliance",
            "Reputational",
            "Governance and management",
            "Workforce",
            "Administration",
            "Client risk"
          ],
          "displayName": "RiskCategory",
          "hidden": false,
          "name": "RiskCategory",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "RiskOwner",
          "hidden": false,
          "name": "RiskOwner",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "RiskOwnerUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "RiskOwnerUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Corporate",
            "Client"
          ],
          "displayName": "RiskRegisterType",
          "hidden": false,
          "name": "RiskRegisterType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "choices": [
            "New",
            "Actioning",
            "Evaluating",
            "Completed",
            "Cancelled"
          ],
          "displayName": "Status",
          "hidden": false,
          "name": "Status",
          "readOnly": false,
          "required": true,
          "type": "choice"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "TreatmentActions",
          "hidden": false,
          "multiline": true,
          "name": "TreatmentActions",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "choices": [
            "Immediate",
            "Within 24 hours",
            "Planned"
          ],
          "displayName": "TreatmentUrgency",
          "hidden": false,
          "name": "TreatmentUrgency",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    },
    "Risk Register Audit Log": {
      "columns": [
        {
          "displayName": "Actor",
          "hidden": false,
          "name": "Actor",
          "readOnly": false,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "ActorUPN",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ActorUPN",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "App Created By",
          "hidden": false,
          "name": "AppAuthor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "App Modified By",
          "hidden": false,
          "name": "AppEditor",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Attachments",
          "hidden": false,
          "name": "Attachments",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created By",
          "hidden": false,
          "name": "Author",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "Compliance Asset Id",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ComplianceAssetId",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Content Type",
          "hidden": false,
          "name": "ContentType",
          "readOnly": false,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Created",
          "format": "dateTime",
          "hidden": false,
          "name": "Created",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "Type",
          "hidden": false,
          "name": "DocIcon",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Edit",
          "hidden": false,
          "name": "Edit",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Modified By",
          "hidden": false,
          "name": "Editor",
          "readOnly": true,
          "required": false,
          "type": "personOrGroup"
        },
        {
          "displayName": "EntryTimestamp",
          "format": "dateTime",
          "hidden": false,
          "name": "EntryTimestamp",
          "readOnly": false,
          "required": false,
          "type": "dateTime"
        },
        {
          "choices": [
            "StateChange",
            "InvestigationStep",
            "ActionTaken",
            "Note"
          ],
          "displayName": "EntryType",
          "hidden": false,
          "name": "EntryType",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "FieldChanged",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "FieldChanged",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Folder Child Count",
          "hidden": false,
          "name": "FolderChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "ID",
          "hidden": false,
          "name": "ID",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Item Child Count",
          "hidden": false,
          "name": "ItemChildCount",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitle",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "name": "LinkTitleNoMenu",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "choices": [
            "Acknowledgement",
            "AuditMeeting",
            "Communication",
            "Consultation",
            "Disclosure",
            "InformationRequest",
            "Notification",
            "ProceduralFairness",
            "ProgressUpdate",
            "RegulatorDecision",
            "RegulatorRequirement",
            "ReprisalConcern",
            "Review",
            "RTW",
            "SitePreservation",
            "Support"
          ],
          "displayName": "LogKind",
          "hidden": false,
          "name": "LogKind",
          "readOnly": false,
          "required": false,
          "type": "choice"
        },
        {
          "displayName": "Modified",
          "format": "dateTime",
          "hidden": false,
          "name": "Modified",
          "readOnly": true,
          "required": false,
          "type": "dateTime"
        },
        {
          "displayName": "NewValue",
          "hidden": false,
          "multiline": true,
          "name": "NewValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Note",
          "hidden": false,
          "multiline": true,
          "name": "Note",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "OldValue",
          "hidden": false,
          "multiline": true,
          "name": "OldValue",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "ParentRef",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "ParentRef",
          "readOnly": false,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Title",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "Title",
          "readOnly": false,
          "required": true,
          "type": "text"
        },
        {
          "displayName": "Color Tag",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_ColorTag",
          "readOnly": true,
          "required": false,
          "type": "text"
        },
        {
          "displayName": "Label setting",
          "hidden": false,
          "name": "_ComplianceFlags",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label",
          "hidden": false,
          "name": "_ComplianceTag",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Label applied by",
          "hidden": false,
          "name": "_ComplianceTagUserId",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Retention label Applied",
          "hidden": false,
          "name": "_ComplianceTagWrittenTime",
          "readOnly": true,
          "required": false,
          "type": "lookup"
        },
        {
          "displayName": "Item is a Record",
          "hidden": false,
          "name": "_IsRecord",
          "readOnly": true,
          "required": false,
          "type": "other"
        },
        {
          "displayName": "Version",
          "hidden": false,
          "maxLength": 255,
          "multiline": false,
          "name": "_UIVersionString",
          "readOnly": true,
          "required": false,
          "type": "text"
        }
      ]
    }
  },
  "source_snapshot_sha256": "ba89457a6f46b957cd1be6244b8c79c9444747da819b8f3af35dc5a2f1ae3f42"
}
